type Range = { min?: number | null; max?: number | null } | null | undefined;

export const rangeIsNullable = (primaryRange: Range, secondaryRange: Range) => {
  return !!(
    (!primaryRange?.min && primaryRange?.min === 0) ||
    (!primaryRange?.min && secondaryRange && secondaryRange?.min === 0)
  );
};
